const {refreshStickyWrapperHeight} = require("./utilities/stickyHelpers");

$(document).ready(function () {
    if (window.resetCampaignBannerSessionToken) {
        window.sessionStorage.removeItem("hide_header_banner");
    }

    var campaignBannerStatus = window.sessionStorage.getItem("hide_header_banner");
    var $campaignBanner = $(".campaign-banner");

    $campaignBanner.find(".close").on("click", function () {
        $campaignBanner.addClass("d-none");
        window.sessionStorage.setItem("hide_header_banner", "1");
        refreshStickyWrapperHeight();
    });

    if (!campaignBannerStatus || campaignBannerStatus < 0) {
        $campaignBanner.removeClass("d-none");
    }
});
